import EmptyError from './error';

export default EmptyError;
